import React                                from "react";
import { createRoot }                       from "react-dom/client";
import * as ServiceWorker                   from "serviceWorker";

// Data
import actions                              from "Utils/Actions";
import params                               from "Utils/Params";
import esStrings                            from "NLS/Strings/es";
import enStrings                            from "NLS/Strings/en";
import esUrls                               from "NLS/Urls/es";
import enUrls                               from "NLS/Urls/en";
import esActions                            from "NLS/Actions/es";
import enActions                            from "NLS/Actions/en";
import store                                from "Stores/RootStores";

// Dashboard
import Dashboard                            from "Dashboard/Dashboard";
import NLS                                  from "Dashboard/Core/NLS";

// Dashboard
import Main                                 from "Components/Core/Main";



// Set the NLS Languages
NLS.initLang("es", esStrings, esUrls, esActions);
NLS.initLang("en", enStrings, enUrls, enActions);
NLS.setLang();



// Render the App
const root = createRoot(document.getElementById("root"));
root.render(
    <Dashboard
        store={store}
        actions={actions}
        params={params}
    >
        <Main />
    </Dashboard>,
);



// Service Worker
ServiceWorker.register({
    onUpdate(registration) {
        console.log("New version available! Ready to update?");
        if (registration && registration.waiting) {
            registration.waiting.postMessage({ type : "SKIP_WAITING" });
        }
        window.location.reload();
    },
});
